import script from "./NoticiaViewPrex.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticiaViewPrex.vue?vue&type=script&setup=true&lang=js"

import "./NoticiaViewPrex.vue?vue&type=style&index=0&id=311f0778&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-311f0778"]])

export default __exports__